import { atom } from 'recoil';
import { DicomProcessor } from '~/domain/services/dicomProcessor';

export const dicomProcessorState = atom<DicomProcessor>({
    key: 'dicomProcessorState',
    default: new DicomProcessor(),
});

export const filesProcessedState = atom<number>({
    key: 'filesProcessedState',
    default: 0,
});

export const filesToProcessState = atom<number | undefined>({
    key: 'filesToProcessState',
    default: undefined,
});
